import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router';

import { stripLegacyAppPrefix } from './app-paths';

export interface LegacyAppPrefixRedirectProps {
  fallback: ReactElement;
}

export const LegacyAppPrefixRedirect = ({
  fallback,
}: LegacyAppPrefixRedirectProps) => {
  const { pathname, search, hash } = useLocation();
  const nextPath = stripLegacyAppPrefix(pathname);

  if (nextPath === pathname) {
    return fallback;
  }

  return <Navigate to={`${nextPath}${search}${hash}`} replace />;
};
